/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

import getSchema from "../../lib/api/getSchema";
import EguCustomerExcelUploadButton from "../input/EguCustomerExcelUploadButton";
import EguCustomerExcelFormDownloadButton from "../input/EguCustomerExcelFormDownloadButton";

import AccessControl from "../functional/AccessControl";
import notificationState from "../../states/notificationState";
import { cloneDeep } from "lodash";

import { Grid, TextField, InputAdornment, makeStyles } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import BasicTabScreenType from "../screenTypes/functional/BasicTabScreenType";
import ExcelUploadSuccess from './ExcelUploadSuccess';
import ExcelUploadError from './ExcelUploadError';

const excelUploadCustomerViewName = "EguVwCustomerExcelUploadSuccess";
const excelUploadCustomerErrorViewName = "EguVwCustomerExcelUploadError";

const useStyle = makeStyles((theme) => ({
    root: {
        paddingTop: "8px",
        width: "120px"
    }
}));

function EguCustomerExcelUpload(props) {
    const classes = useStyle();

    const [schema, setSchema] = useState();
    const [modifiedSchema, setModefiedSchema] = useState();
    const [tab, setTab] = useState("successView");
    const [api, setApi] = useState(null);
    const [, setSearch] = useState();
    const [, setSearchVal] = useState();

    const setNotification = useSetRecoilState(notificationState);

    const {t} = useTranslation();

    useEffect(() => {
        let mounted = true;
        async function modifiedSchemaSetting() {
            let schema = await getSchema("EguExcelUploadError");
            if(mounted) {
                let modifiedSchema = cloneDeep(schema);
                modifiedSchema.columns.forEach(column => columnSetting(column));
                setSchema(schema);
                setModefiedSchema(modifiedSchema);
            }
        }

        function columnSetting(column) {
            if(column.name !== "excelFile") {
                column.hideInForm = true;
                column.required = false;
            }
        }

        modifiedSchemaSetting();

        return(() => {
            mounted = false;
        });
    }, []);

    const onApiInitialized = (api) => {
        setApi(api);
    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onTabChanged = (tab) => {
        setTab(tab);
    };
    
    const onSearchInitialized = (search) => {
        setSearch(search);
        setSearchVal((searchVal) => {
            if(searchVal) {
                search.applySearch(searchVal);
            }
            return searchVal;
        } );
    }

    const onChangeSearch = (e) => {
        setSearch((search) => {
            if(search) {
                setSearchVal(e.target.value);
                search.applySearch(e.target.value);
            }
            return search;
        });
    };

    return (
        <BasicTabScreenType
            id="customerExcelUpload"
            tabs={["successView", "errorView"]}
            tabLabels={["엑셀 업로드 성공", "엑셀 업로드 실패"]}
            tabsStyle={{
                left: 0,
                margin: "0px",
                padding:"0px",
                height: "48px",
                width: "450px"
            }}
            onTabChanged={onTabChanged}
            value={tab}
            rightGridItems={
                [
                    <Grid item>
                        <AccessControl accessTarget={schema && schema.name} accessMethod="GET">
                            <EguCustomerExcelFormDownloadButton
                                id = "EguCustomerExcelFormDownload"
                                schema = {schema}
                                refresh = {api}
                                onSuccess = {onSuccess}
                            />
                        </AccessControl>

                        <AccessControl accessTarget={modifiedSchema && modifiedSchema.name} accessMethod="POST">
                            <EguCustomerExcelUploadButton
                                id = "EguCustomerExcelUpload"
                                createButtonName = "excelUpload"
                                schema = {modifiedSchema}
                                refresh = {api}
                                onSuccess = {onSuccess}
                                modifyUrlCallback={(url) => `${url}?customerExcelUpload`}
                            />
                        </AccessControl>
                    </Grid>,
                    <Grid item>
                        <TextField
                            id={"customer-excel-upload-search"}
                            className={classes.root}
                            placeholder={t("common.search")}
                            onChange={onChangeSearch}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>                    
                                )
                            }}
                            style={{
                                bottom: "2px",
                                width: "120px"                        
                            }}
                        />
                    </Grid>
                ]
            }
        >
            <EguCustomerExcelUploadView
                viewName={tab}
                onSearchInitialized={onSearchInitialized}
                onApiInitialized={onApiInitialized}
                api={api}
            />
        </BasicTabScreenType>
    );
}

function EguCustomerExcelUploadView(props) {
    const { viewName, onSearchInitialized, onApiInitialized } = props;

    switch(viewName) {
        case "successView":
            return <ExcelUploadSuccess 
                id='EguCustomerExcelUploadSuccess'
                table={excelUploadCustomerViewName}
                view={excelUploadCustomerViewName}
                onSearchInitialized={onSearchInitialized}
                onApiInitialized={onApiInitialized}
                fixedOrder={[{column: "createdAt", order: "DESC"}]}
            />

        case "errorView":
            return <ExcelUploadError
                id='EguCustomerExcelUploadError'
                table={excelUploadCustomerErrorViewName}
                view={excelUploadCustomerErrorViewName}
                onSearchInitialized={onSearchInitialized}
                onApiInitialized={onApiInitialized}
                fixedOrder={[{column: "createdAt", order: "DESC"}]}
            />

        default:
            return <></>;
    }
}

export default EguCustomerExcelUpload;
